import { render, staticRenderFns } from "./v-dialog.vue?vue&type=template&id=2fbad45a&scoped=true&"
import script from "./v-dialog.vue?vue&type=script&lang=js&"
export * from "./v-dialog.vue?vue&type=script&lang=js&"
import style0 from "./v-dialog.vue?vue&type=style&index=0&id=2fbad45a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbad45a",
  null
  
)

export default component.exports